import React from 'react'
import DocumentTitle from 'react-document-title'

import {withStyles, Grid, Typography, Card, CardContent, Button, Icon} from 'material-ui'


const styles = theme => ({
    ...theme,
    footer: {
        display: 'flex',
        alignItems: 'flex-begin',
        padding: 20,
        backgroundColor: "#324058",
    },
    footerBlock: {
        marginTop: "3em",
        marginBottom: "-4em",
    },
    content: {
        padding: 20,
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        marginBottom: 60,
        '& h1': theme.typography.display1,
        '& h2': theme.typography.headline,
        '& h3': theme.typography.subheading,
        '& p': theme.typography.body1,
        '& caption': theme.typography.caption,
        '& a': {
            ...theme.typography.body1,
            color: "#8893A3",
            textDecoration: "none",
        },

    },
    grow: {
        flex: 1
    },
    card: {
        backgroundColor: "#425671",
        minHeight: "10em",
        minWidth: "18em",
    },
    cardContent: {
        minHeight: "8em",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
    },
    icon: {
        color: "white",
        fontSize: "2.5em",
    },
    linkColor: {
        color: "#8893A3",
        marginRight: "2em"
    },
})

const address = <span>75 5th St. NW, Suite 2000<br/>Atlanta, GA 30308</span>
const call = <a href='https://calendly.com/carefolio/call' target='blank'>Schedule a Call</a>
const email = <a href='mailto:info@carefol.io'>info@carefol.io</a>
const location = <a href='https://goo.gl/maps/PLLEHtcbauK2' target='blank'>{address}</a>

export const Footer = withStyles(styles)(
    ({classes}) => (
    <div className={classes.footer}>
        <div className={classes.content}>
            <Grid container spacing={24}>
                <Grid item xs>
                    <ContactCard
                        title="Phone"
                        text={call}
                        icon='phone'/>
                </Grid>
                <Grid item xs>
                    <ContactCard
                        title="Email"
                        text={email}
                        icon='email'/>
                </Grid>
                <Grid item xs>
                    <ContactCard
                        title="Location"
                        text={location}
                        icon='location_on'/>
                </Grid>
                <Grid item xs={12}>
                    <FooterBlock/>
                </Grid>
            </Grid>
        </div>
    </div>
    )
)

export const ContactCard = withStyles(styles) (
    ({classes, icon, title, text}) => (
        <Card className={classes.card} raised={false}>
            <CardContent className={classes.cardContent}>
            <Typography align="center">
                <Icon className={classes.icon}>{icon}</Icon>
            </Typography>
            <Typography component="p" align="center" style={{color: "white"}}>
                {title}
            </Typography>
            <Typography component="p" align="center" style={{color: "#8893A3"}}>
                <strong>{text}</strong>
            </Typography>
            </CardContent>
        </Card>
    )
)

export const FooterBlock = withStyles(styles) (
    ({classes}) => (
        <Grid container spacing={24} className={classes.footerBlock}>
            <Grid item xs={12}>
                <Typography component="caption" align="center" style={{color: "white"}}>
                    <Icon style={{fontSize: "0.5em"}}>copyright</Icon> 2018 All Rights Reserved
                </Typography>
                <br/>
                <Typography component="caption" align="center" style={{color: "white"}}>
                    <a className={classes.linkColor} href="https://app.carefol.io/legal/tos">Terms of Service</a>
                    <a className={classes.linkColor} href="http://www.carefol.io">Carefolio</a>
                    <a className={classes.linkColor} href="https://app.carefol.io/legal/privacy">Privacy Policy</a>
                </Typography>
            </Grid>
        </Grid>
    )
)


export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.jsx